<form class="mce-form-section">

    <div class="mce-form-section-title">Protection</div>

    <div class="mce-form-field-group">


        <div class="flex-grow flex-col">

            <div class="flex-grow" [class.mce-form-field-disabled]="deviceKindsRx.isLoading()">
                <mat-form-field class="w-full">
                    <mat-label>protective device</mat-label>
                    <mat-select [formField]="form().deviceKind">
                        @for (option of deviceKinds(); track option.value) {
                        <mat-option [value]="option.value">{{option.label}}</mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            </div>

            @if (form().deviceKind().value()) {

            <div>
                <mat-checkbox matTooltip="Simple Design Current ignores any protective device overcurrent in calculations. Use cautiously and ensure you are complying with regulations."
                              [formField]="settings().simpleDesignCurrent">Simple Design Current</mat-checkbox>
            </div>
            }

        </div>


        <div class="flex-grow">

            @switch(form().deviceKind().value()) {

            @case("GeneralProtectiveDevice") {
            <protection-general-device [form]="form().generalDevice"></protection-general-device>
            }

            @case("ACB_IEC60947") {
            <protection-acb [form]="form().acbIEC60947" [load]="load()"></protection-acb>
            }

            @case("MCCB_IEC60947") {
            <protection-mccb [form]="form().mccbIEC60947" [load]="load()"></protection-mccb>
            }

            @case("MCB_IEC60898") {
            <protection-mcb [form]="form().mcbIEC60898" [load]="load()"></protection-mcb>
            }

            @case("Fuse_IEC60269") {
            <protection-fuse-iec60269 [form]="form().fuseIEC60269" [load]="load()"></protection-fuse-iec60269>
            }

            @case("Fuse_BS3036") {
            <protection-fuse-bs3036 [form]="form().fuseBS3036" [load]="load()"></protection-fuse-bs3036>
            }

            @case("Fuse_BS88") {
            <protection-fuse-bs88 [form]="form().fuseBS88" [load]="load()"></protection-fuse-bs88>
            }

            @case("RCBO_IEC61009") {
            <protection-rcbo [form]="form().rcboIEC61009" [load]="load()"></protection-rcbo>
            }

            }

        </div>


    </div>


    <app-calculation-box [status]="designCurrentStatus()" [loading]="designCurrentRx.isLoading()">

        <div>
            Load Current: {{$safeNavigationMigration(designCurrent()?.loadCurrent) | number:'1.0-3'}} A;
            Protective Device Current: {{designCurrent()?.protectiveDeviceCurrent  | number:'1.0-3'}} A [{{$safeNavigationMigration(designCurrent()?.protectiveDeviceMargin) | number:'1.0-0'}}% margin];
            Design Current: {{$safeNavigationMigration(designCurrent()?.designCurrent) | number:'1.0-3'}} A
        </div>

    </app-calculation-box>

</form>
